import { render, staticRenderFns } from "./AdminTasksPage.vue?vue&type=template&id=8e17d382"
import script from "./AdminTasksPage.vue?vue&type=script&lang=js"
export * from "./AdminTasksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports